import { parseTL } from "../components/AmountInput";

const finiteOr0 = (n) => (Number.isFinite(n) ? n : 0);
export const finiteOrNull = (n) => (Number.isFinite(n) ? n : null);

// Kayıt formu için aktif atama kartı: düzenlemede yok; birden fazla kart varsa seçilen taşerona göre
export function resolveAssignment({ editMode, assignOptions, subcontractorId }) {
  if (editMode) return { multiMode: false, assignment: null };
  const list = assignOptions || [];
  const multiMode = list.length > 1;
  if (multiMode) return { multiMode, assignment: list.find((a) => a.subcontractor_id === subcontractorId) || null };
  return { multiMode, assignment: list.length === 1 ? list[0] : null };
}

// Miktar × birim fiyat hesapları (atama kartı / manuel / başka taşeron / fiyat farkı)
export function computePricing({ form, editMode, assignOptions, baskaTaseron, telafi, fiyatFarki, ffPrice, hasService }) {
  const qty = parseTL(form.quantity);
  const validQty = Number.isFinite(qty) && qty > 0;
  const manualSell = parseTL(form.sell_price);
  const manualBuy = parseTL(form.buy_price);
  const { multiMode, assignment } = resolveAssignment({ editMode, assignOptions, subcontractorId: form.subcontractor_id });
  const hasCardPrices = !!assignment && ((assignment.sell_price || 0) > 0 || (assignment.buy_price || 0) > 0);
  const baskaOverride = baskaTaseron && !!assignment && !!form.subcontractor_id && form.subcontractor_id !== assignment.subcontractor_id;
  const sellPrice = hasCardPrices ? assignment.sell_price || 0 : finiteOr0(manualSell);
  let buyPrice = finiteOr0(manualBuy);
  if (!baskaOverride && hasCardPrices) buyPrice = assignment.buy_price || 0;
  const counts = hasService && validQty && !telafi;
  const custTotal = counts ? qty * sellPrice : 0;
  const subTotal = counts ? qty * buyPrice : 0;
  const ffNewPrice = parseTL(ffPrice);
  const ffNewTotal = fiyatFarki && validQty && Number.isFinite(ffNewPrice) ? qty * ffNewPrice : 0;
  return { qty, validQty, manualSell, manualBuy, multiMode, assignment, hasCardPrices, baskaOverride, sellPrice, buyPrice, custTotal, subTotal, profit: custTotal - subTotal, ffNewPrice, ffNewTotal, ffDiff: ffNewTotal - subTotal };
}

// Ana başlık adından puantaj modu: ASIL PERSONEL / GEÇİCİ PERSONEL
export function categoryFlags(category) {
  const norm = (category?.name || "").replace(/ı/g, "i").replace(/İ/g, "I").replace(/ç/g, "c").replace(/Ç/g, "C").toUpperCase();
  const isPersonnelCategory = !!category && /ASIL\s*PERSONEL/.test(norm);
  const isTempCategory = !!category && /GECICI\s*PERSONEL/.test(norm);
  return { isPersonnelCategory, isTempCategory };
}

export const APPR_MATCH = {
  all: () => true,
  approved: (e) => e.approval_status === "approved",
  unapproved: (e) => e.approval_status !== "approved",
};

const byBranchCode = (a, b) => (parseInt(a.branch_code) || 999999) - (parseInt(b.branch_code) || 999999) || (a.name || "").localeCompare(b.name || "", "tr");
export const locationOptions = (locs) => [...locs].sort(byBranchCode).map((l) => ({ value: l.id, label: [l.branch_code, l.name, l.city].filter(Boolean).join(" - ") }));
export const byLabelTr = (a, b) => a.label.localeCompare(b.label, "tr");
